// extracted by mini-css-extract-plugin
module.exports = {"reservationsCreatedTable":"reservationsCreatedTable_reservationsCreatedTable__1QEKs"};